class HHCarouselSlick extends HTMLElement {
  constructor() {
    super()

    this.type = this.dataset.type || ''
    this.autoRotate = parseInt(this.dataset.autoRotate) || 0
    this.slidesToShow = parseInt(this.dataset.slidesToShow) || 3
    this.slider = this.querySelector('.js-carousel-slick')
    this._doSlider = this._doSlider.bind(this)
  }

  connectedCallback() {
    this.type = this.dataset.type || ''
    this.autoRotate = parseInt(this.dataset.autoRotate) || 0
    this.slider = this.querySelector('.js-carousel-slick')

    setTimeout(() => {
      this._doSlider()
    }, 300)
  }

  _doSlider() {
    const config = {
      slidesToShow: this.slidesToShow,
      slidesToScroll: 1,
      dots: false,
      responsive: []
    }

    switch (this.type) {
      case 'contents':
        config.arrows = false
        config.responsive = [
          {
            breakpoint: 990,
            settings: {
              centerMode: true,
              slidesToShow: 1,
              dots: true,
              variableWidth: true
            }
          }
        ]
        break;
      default:
        config.arrows = true
        config.variableWidth = true
        config.responsive = [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              arrows: false
            }
          }
        ]
        break;
    }

    if (this.autoRotate) {
      config.autoplay = true
      config.autoplaySpeed = this.autoRotate
    }

    $(this.slider).slick(config)
  }
}

customElements.define('hh-carousel-slick', HHCarouselSlick)
